// @flow
import {useQuery} from '@tanstack/react-query';
import type {UseQueryReturn} from '@tanstack/react-query';
import {analyticsOrganizationEventsList} from 'api/v2';
import type {
  PaginatedOrganizationEventsList,
  AnalyticsOrganizationEventsListParams,
} from 'api/v2';

export const useOrganizationEventsList = (
  params: AnalyticsOrganizationEventsListParams,
): UseQueryReturn<PaginatedOrganizationEventsList, any> => {
  const query = useQuery({
    queryKey: ['organizationEventsList', params],
    queryFn: () => analyticsOrganizationEventsList(params),
    select: (response) => response.data,
  });

  return query;
};
